/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CreateCallbackOutcome = {
    AssignmentForCounselor: 'AssignmentForCounselor',
    AssignmentForSubstitute: 'AssignmentForSubstitute',
    Ambulanz: 'Ambulanz'
} as const;
export type CreateCallbackOutcome = typeof CreateCallbackOutcome[keyof typeof CreateCallbackOutcome];


export function instanceOfCreateCallbackOutcome(value: any): boolean {
    for (const key in CreateCallbackOutcome) {
        if (Object.prototype.hasOwnProperty.call(CreateCallbackOutcome, key)) {
            if (CreateCallbackOutcome[key as keyof typeof CreateCallbackOutcome] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CreateCallbackOutcomeFromJSON(json: any): CreateCallbackOutcome {
    return CreateCallbackOutcomeFromJSONTyped(json, false);
}

export function CreateCallbackOutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCallbackOutcome {
    return json as CreateCallbackOutcome;
}

export function CreateCallbackOutcomeToJSON(value?: CreateCallbackOutcome | null): any {
    return value as any;
}

export function CreateCallbackOutcomeToJSONTyped(value: any, ignoreDiscriminator: boolean): CreateCallbackOutcome {
    return value as CreateCallbackOutcome;
}

